import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalsService } from 'app/services/globals.service';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { PrintService } from 'app/services/print.service';
import { ReportsService } from 'app/services/reports.service';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-spiff-report',
	templateUrl: './spiff-report.component.html',
	styleUrls: ['./spiff-report.component.scss']
})

export class SpiffReportComponent implements OnInit {

	@ViewChild('spiffEditor') posRecRef: ElementRef;

	today = new Date();
	fromdate = new Date();
	todateCtrl = new UntypedFormControl(this.today);
	fromdateCtrl = new UntypedFormControl(new Date(this.fromdate.setDate(1)));

	todateCtrlSetup = new UntypedFormControl(this.today);
	fromdateCtrlSetup = new UntypedFormControl(new Date(this.fromdate.setDate(1)));

	locations: any = [];
	defaultlocation = new UntypedFormControl('');
	salespeople: any = [];
	salespersonRef = new UntypedFormControl('');
	searchInputItems = new UntypedFormControl('');
	searchInput = new UntypedFormControl('');

	// editor
	excludedDt = new UntypedFormControl('');
	excludedLoc = new UntypedFormControl('');
	spifftype = new UntypedFormControl('0', [Validators.required]);
	spiffname = new UntypedFormControl('', [Validators.required]);
	spifftypes: any = [ { 'value': '0', 'view':'Store' }, { 'value': '1', 'view':'Salesman' }]
	spiffitems: any = [];
	spiffs: any = [];
	dtypes: any = [];
	

	loading: any = false;
	user: any = false;
	color: any = false;
	config: any = false;
	adminuser: any = false;


	addingitems: any = false;

	allspiffs: any = [];
	spiffnames: any = [];
	nameValid: any = false;

	//report data
	storespiff: any = false;
	salesmanspiff: any = false;

	currentitems: any = [];

	editorindex = 0;
	editingconfig: any = false;

	totalinfo: any =false;

	currentindex = 0;

	currentreport: any = false;
	spiffrunning = false;
	reportfiltered: any = false;

	title: any = 'Spiff Report';
	getting: any = false;
	getNewData = false;


	#pagers
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	dataSource: MatTableDataSource < any > ;
	dataObs: Observable < any > ;
	items_per_page = [5, 10, 20, 100, 500, 1000];
	pagesizedefault = 20;

	store = false;
	salesman = false;
	
	

	constructor(private _cdr: ChangeDetectorRef,private globalSearchService: GlobalSearchService, private reportsService: ReportsService, private modalService: NgbModal, private globalsService: GlobalsService, private printService: PrintService) {

	}

	setPagination(data: any[]) {
		if(typeof data !== 'object'){
			data = [];
		}
		
		this.dataSource = new MatTableDataSource<any>(data);
		this.dataSource.paginator = this.paginator;
		this.dataObs = this.dataSource.connect();
		this.reportfiltered = data;

		setTimeout(() => {
			this._cdr.detectChanges();
		},200)
	}


	ngOnInit(): void {
		this.globalSearchService.user.subscribe(results => {
			this.user = results
			//summit admin group = 1
			//aa admin group 1 / bo admin 13
			if(this.user.user.userid == 'JACK' || (this.user.user.user_group == '1' || this.user.user.user_group == '13' )){
				this.adminuser = true;
			}
			this.globalSearchService.locations.subscribe(async (results: any) => {
				this.locations = results;
			});
		});

		this.reportsService.getSalesPeople().subscribe((results: any) => {
			this.salespeople = results;
		});

		this.globalsService.getCustomerTypes().subscribe((res) => {
			this.dtypes = res;
		})

		this.getspiffs();
		//default to store?
		this.spifftype.setValue('0');

		this.spiffname.valueChanges.subscribe((newV) => {
			if(newV != '' &&  !this.spiffnames.includes(newV.toUpperCase())){
				this.nameValid = true;
			}else{
				this.nameValid = false;
			}
		})

		this.runSpiff();
	}

	removeitem(index){
		this.spiffitems.splice(index, 1);
		this.currentitems.splice(index, 1);
	}

	openEditor(){
		this.reportsService.getSpiffConfig().subscribe((res: any) => {
			this.allspiffs = res;
			this.spiffnames = res.map((r) => r.name.toUpperCase());
			this.modalService.open(this.posRecRef, { ariaLabelledBy: 'modal-title', size: 'zip' }).result.then((result) => {}, (reason) => {
				if(this.getNewData){
					this.runSpiff();
				}
				this.getNewData = false;
				this.cancel();
			});
		});
	}

	getspiffs(){
		this.reportsService.getSpiffConfig().subscribe((res: any) => {
			this.allspiffs = res;
			this.spiffnames = res.map((r) => r.name.toUpperCase()) ?? [];
		});
	}

	itemsSelected(event){
		if(!this.spiffitems.length){
			this.spiffitems = event;
		}else{
			const present = this.spiffitems.map((item) => item.stockid);
			event.forEach(item => {
				if(!present.includes(item.stockid)){
					this.spiffitems.push(item);
				}
			});
		}
		this.addingitems = false;
		this.currentitems = event;
	}

	save(){
		//adds or updates if reused - sets to active for type? no
		
		const data = {
			dtypes: this.excludedDt.value,
			from: this.fromdateCtrlSetup.value,
			to: this.todateCtrlSetup.value,
			setactive: true,
			items: this.spiffitems,
			typeid: this.spifftype.value,
			name: this.spiffname.value,
			locs: this.excludedLoc.value
		}

		this.reportsService.saveSpiffConfig(data).subscribe((res) => {
			if(res.success){
				this.globalSearchService.showNotification(res.msg, 'success', 'bottom', 'left');
				this.getNewData = true;
				this.modalService.dismissAll()
			}else{
				this.globalSearchService.showNotification(res.msg, 'danger', 'bottom', 'left');
			}
		})
	}

	setActive(config){
		const data ={
			id: config.id,
			setactive: true,
			type: config.type
		}
		this.reportsService.setSpiffActive(data).subscribe((res) => {
			if(res.success){
				this.getNewData = true;
				this.globalSearchService.showNotification(res.msg, 'success', 'bottom', 'left');
			}else{
				this.globalSearchService.showNotification(res.msg, 'danger', 'bottom', 'left');
			}
			this.getspiffs();
		})
	}

	update(){
		//adds or updates if reused
		
		const data = {
			dtypes: this.excludedDt.value,
			from: this.fromdateCtrlSetup.value,
			to: this.todateCtrlSetup.value,
			setactive: false,
			items: this.spiffitems,
			typeid: this.spifftype.value,
			name: this.spiffname.value,
			locs: this.excludedLoc.value,
			update: true,
			original: this.editingconfig
		}

		this.reportsService.updateSpiffConfig(data).subscribe((res) => {
			if(res.success){
				this.globalSearchService.showNotification(res.msg, 'success', 'bottom', 'left');
				this.modalService.dismissAll()
				this.getNewData = true;
			}else{
				this.globalSearchService.showNotification(res.msg, 'danger', 'bottom', 'left');
			}
		})
	}

	cancel(){
		this.spiffitems = false;
		this.currentitems = false;
		this.editingconfig = false;

		this.spiffname.setValue('');
		this.fromdateCtrlSetup.setValue(new Date());
		this.todateCtrlSetup.setValue(new Date());
		this.spifftype.setValue('');
		this.excludedLoc.setValue([]);
		this.excludedDt.setValue([]);

	}

	runSpiff(){
		this.spiffrunning = true;
		this.searchInput.setValue('');
		this.currentreport = false;
		this.reportfiltered = [];
		this.salesmanspiff = false;
		this.storespiff = false;

		if(this.getting){
			this.getting.unsubscribe();
		}
		const data = { user: this.user }
		this.getting = this.reportsService.runSpiff(data).subscribe((res: any) => {
			this.spiffrunning = false;

			this.salesmanspiff = res.salesman;
			this.storespiff = res.store;

			if(!this.currentindex){
				this.store = false;
				this.salesman = true;
				this.currentreport = res.salesman;
			}else{
				this.store = true;
				this.salesman = false;
				this.currentreport = res.store
			}
			this.filter();
		})
	}

	editSpiff(config){
		const fd = config.fromdate.split('-');
		const fdate = `${fd[1]}-${fd[2]}-${fd[0]}`;
		
		const td = config.todate.split('-');
		const tdate = `${td[1]}-${td[2]}-${td[0]}`;

		this.spiffname.setValue(config.name);
		this.fromdateCtrlSetup.setValue(new Date(fdate));
		this.todateCtrlSetup.setValue(new Date(tdate));
		this.spifftype.setValue(config.type);

		this.excludedLoc.setValue(config.excludedlocs.replaceAll('"', '').split(','));
		this.excludedDt.setValue(config.excludeddebtors.replaceAll('"', '').split(','));

		this.spiffitems = config.items;
		this.currentitems = config.items;
		this.addingitems = false;

		this.editorindex = 0;
		this.editingconfig = config;
	}


	updateRange(start?, modal?) {
		const todate = modal ? this.todateCtrlSetup : this.todateCtrl; 
		const fromdate = modal ? this.fromdateCtrlSetup : this.fromdateCtrl;
		if (start) {
			todate.setValue(null);
		} else {
			if (fromdate.value !== null && todate.value !== null && fromdate.value <= todate.value) {
				this.loading = false;
			}
		}
	}


	totals(data: any, ret?){
		let units = 0;
		let tot = 0;
		let avg = 0;
		data.forEach((row) => {
			units += Number(row.qty)
			tot += Number(row.totalSales)
		})
		avg = tot / units;

		if(ret){
			return {
				units: units,
				tot: this.financial(tot),
				avg: this.financial(avg)
			}
		}else{
			this.totalinfo = {
				units: units,
				tot: this.financial(tot),
				avg: this.financial(avg)
			}
		}
		
	}


	removeConfig(config){
		const id = config.id;
		if(id != ''){
			this.reportsService.removeSpiffConfig(id).subscribe((res: any)=>{
				if(res.length){
					this.allspiffs = res;
					this.spiffnames = res.map((r) => r.name.toUpperCase()) ?? [];
				}else{
					this.getspiffs();
				}
			})
		}
	}


	export(type){
		const html = this.buildHtml(this.currentindex);
		const now = new Date();
		const encoded: string = this.globalSearchService.base64encode(html);
		const report = this.currentreport;
		const reporttype = this.currentreport.type == '0' ? 'Store' : 'Salesman';


		const data = {
			content: encoded,
			filename: 'SPIFF-' +report.name + '-' + (now.getMonth() + 1) + now.getDate() + now.getFullYear(),
			title: `${reporttype} Spiff Report - Created @ ${now.toLocaleString()}`,
			subtitle: report.name
		}

		if(type == 'pdf'){
			this.printService.pdf(data).subscribe((result: any) => {
				this.globalSearchService.downloadPdf(result.content, data.filename);
			});
		}else{
			this.printService.xls(data).subscribe((result: any) => {
				this.globalSearchService.downloadXls(result.content, data.filename);
			});
		}
	}




	buildHtml(type){
		const data = this.reportfiltered;
		let wanted;
		if(!type){
			//sales
			wanted = ['loccode', 'salesmanname', 'stockid', 'supplier' , 'description', 'qty', 'Price', 'totalSales'];
		}else{
			//store
			wanted = ['loccode', 'stockid', 'supplier', 'description', 'qty', 'Price', 'totalSales'];
		}

		let html = '<table style="width: 100% !important"><thead><tr>';
		html += '<th>Location</th>';
		if(type !== 1){
			html += '<th>Salesman</th>'
		}
		html += '<th style="text-align: left;">Stockid</th>';
		html += '<th style="text-align: left;">Supplier</th>';
		html += '<th>Description</th>';
		html += '<th style="text-align: right;">Qty</th>';
		html += '<th style="text-align: right;">Price</th>';
		html += '<th style="text-align: right;">Total</th></tr></thead><tbody>';

		data.forEach(row => {
			html += '<tr>';
			wanted.forEach((k) => {
				if(row[k]){
					let style = ''
					if(k == 'stockid' || k == 'supplier'){ style = ' style="text-align: left;" ' };
					if(k == 'qty' || k == 'Price' || k == 'totalSales'){ style = ' style="text-align: right;" ' };
					html += `<td ${style} >${row[k]}</td>`;
				}
			})
			html += '</tr>';
		});

		const tots = this.totals(data, true);
		html += '<tr>';
		html += `<td colspan="${!type ? 5 : 4}"></td>`
		html += `<td style="text-align: right;">Units: ${tots.units}</td>`
		html += `<td style="text-align: right;">Avg: ${tots.avg}</td>`
		html += `<td style="text-align: right;">Total: ${tots.tot}</td>`
		html += '</tr>';

		html += '</tbody></table>'


		return html;
	}


	financial(x) {
		if (Number.isNaN(x)) {
			x = 0
		}
		return parseFloat(Number.parseFloat(x).toFixed(2));
	}


	filter(){
		const ev = this.searchInput.getRawValue() ?? '';
		let rep = this.currentreport.items;
		
		//drop down filters
		const locs = this.defaultlocation.getRawValue();
		const sales = this.salespersonRef.getRawValue();
		if(locs.length || sales.length){
			rep = rep.filter((row) => {
				if(locs.includes(row.loccode) || sales.includes(row.salespersonname)) {
					return row;
				}
			})
		}
		
		//search input
		if(ev.length){
			const wanted = ['loccode', 'supplier', 'suppliername', 'stockid', 'description', 'salesmanname'];
			function buildrow(r){
				let out = '';
				wanted.forEach(k => { out += r[k] + '^^'; })
				return out.toUpperCase();
			}
			rep = rep.filter((i) => {
				if(buildrow(i).includes(ev.toUpperCase())){
					return i;
				}
			})
		}

		
		this.setPagination(rep);
	}

	tabchange(ev){
		this.currentindex = ev;
		this.currentreport = false;
		this.salesman = false;
		this.store = false;
		if(!this.currentindex){
			this.salesman = true;
			this.currentreport = this.salesmanspiff;
		}else{
			this.store = true;
			this.currentreport = this.storespiff;
		}

		
		this.filter();
	}

}
